import { defineComponent as _defineComponent } from 'vue'
import { B_SIZE, B_VARIANT, BUTTON_TYPE } from "@/types/frontend/enums/bootstrapEnums";

interface ButtonBaseProps {
    active?: boolean;
    activeClass?: string;
    block?: boolean;
    disabled?: boolean;
    href?: string;
    pill?: boolean;
    pressed?: boolean;
    size?: B_SIZE;
    squared?: boolean;
    tag?: string;
    type?: BUTTON_TYPE;
    variant?: B_VARIANT;
    start?: boolean;
    end?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonBase',
  props: {
    active: { type: Boolean },
    activeClass: null,
    block: { type: Boolean },
    disabled: { type: Boolean },
    href: null,
    pill: { type: Boolean },
    pressed: { type: Boolean },
    size: null,
    squared: { type: Boolean },
    tag: null,
    type: null,
    variant: { default: B_VARIANT.PRIMARY },
    start: { type: Boolean },
    end: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})